import CurrentAccountProvider from "../providers/current-account-provider";
import { Wrapper } from "./wrapper";

const AdminSettings = () => {
  return (
    <CurrentAccountProvider>
      <Wrapper />
    </CurrentAccountProvider>
  );
};

export default AdminSettings;
